var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LanguageSelect',{attrs:{"initialValue":_vm.selectedLocale,"label":_vm.label,"aria-label":_vm.ariaLabel,"locales":_vm.availableLocales,"theme":_vm.theme,"item-color":_vm.theme === _vm.themes.DARK ? 'white' : 'black'},on:{"change":_vm.handleLanguageSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }